import React, { Component } from 'react';
import * as Styles from './Styles';
import Form from './form/Form';
import Consents from './consents/Consents';
import Controls from './controls/Controls';

type Props = {};

type State = {};

class FormView extends Component<Props, State> {
	state: State = {};

	render() {
		return (
			<Styles.Wrapper>
				<Form />
				<Consents />
				<Controls />
			</Styles.Wrapper>
		);
	}
}

export default FormView;
